var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 164,
    viewBox: "0 0 181 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.041 29.6697C164.616 22.9895 154.423 22.1248 147.021 27.201C146.511 18.5511 140.001 11.1503 131.089 9.83717C122.531 8.58012 114.484 13.3308 111.217 20.9078C109.196 12.5835 101.624 6.48503 92.6957 6.6505C82.3794 6.85334 74.1797 15.3805 74.3826 25.6958L74.855 49.6945C75.0552 59.8843 83.3803 68.0085 93.5284 68.0085C93.6539 68.0085 93.7793 68.0084 93.9048 68.0058C99.7903 67.891 104.984 65.062 108.326 60.7384C111.009 65.844 116.008 69.6445 122.15 70.5492C123.073 70.6854 123.989 70.7494 124.894 70.7494C125.105 70.7494 125.315 70.7414 125.526 70.7361C125.919 71.2405 126.343 71.7289 126.794 72.1986C130.462 76.0151 135.359 77.9341 140.265 77.9341C145.171 77.9341 149.589 76.202 153.211 72.7191L170.515 56.0838C177.954 48.9338 178.186 37.1053 171.035 29.6671L171.041 29.6697Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.779 103.498C179.779 145.979 139.662 163.671 90.1758 163.671C40.6897 163.671 0.572266 145.979 0.572266 103.498C0.572266 61.017 40.6897 37.3252 90.1758 37.3252C139.662 37.3252 179.779 61.017 179.779 103.498Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1430_17308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 6,
    width: 103,
    height: 57
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.479 62.8521L170.52 56.0838C177.959 48.9338 178.191 37.1053 171.041 29.6671C164.616 22.9868 154.423 22.1221 147.021 27.1983C146.511 18.5484 140.001 11.1476 131.089 9.8345C122.531 8.57745 114.484 13.3281 111.217 20.9051C109.196 12.5835 101.624 6.48503 92.6957 6.6505C82.3794 6.85334 74.1797 15.3805 74.3826 25.6958L74.6281 38.1382C79.6782 37.599 84.8724 37.3268 90.176 37.3268C120.476 37.3268 147.264 46.2116 163.479 62.8521Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1430_17308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4691 11.4084C80.7052 48.4688 146.668 68.8858 177.515 36.1144L182.109 73.7993L53.6133 55.987L73.4691 11.4084Z",
    fill: "#E7E7E7"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.874 107.839C154.874 137.842 125.908 152.225 90.1762 152.225C54.4442 152.225 25.4785 137.842 25.4785 107.839C25.4785 77.8348 54.4442 62.9851 90.1762 62.9851C125.908 62.9851 154.874 77.8322 154.874 107.839Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1430_17308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 62,
    width: 130,
    height: 91
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.874 107.839C154.874 137.842 125.908 152.225 90.1762 152.225C54.4442 152.225 25.4785 137.842 25.4785 107.839C25.4785 77.8348 54.4442 62.9851 90.1762 62.9851C125.908 62.9851 154.874 77.8322 154.874 107.839Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1430_17308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3356 147.67C58.4825 147.67 68.3295 137.824 68.3295 125.678C68.3295 113.532 58.4825 103.686 46.3356 103.686C34.1888 103.686 24.3418 113.532 24.3418 125.678C24.3418 137.824 34.1888 147.67 46.3356 147.67Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.017 147.67C146.164 147.67 156.011 137.824 156.011 125.678C156.011 113.532 146.164 103.686 134.017 103.686C121.87 103.686 112.023 113.532 112.023 125.678C112.023 137.824 121.87 147.67 134.017 147.67Z",
    fill: "#8D8D8D"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.786 124.076C124.445 124.076 124.103 123.945 123.842 123.686C123.321 123.166 123.321 122.32 123.842 121.799L129.546 116.096C130.066 115.575 130.912 115.575 131.433 116.096C131.953 116.616 131.953 117.462 131.433 117.983L125.729 123.686C125.467 123.948 125.125 124.076 124.784 124.076H124.786Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.972 124.076C131.63 124.076 131.289 123.945 131.027 123.686C130.507 123.166 130.507 122.32 131.027 121.799L134.334 118.492C134.855 117.972 135.701 117.972 136.221 118.492C136.742 119.013 136.742 119.859 136.221 120.379L132.914 123.686C132.653 123.948 132.311 124.076 131.969 124.076H131.972Z",
    fill: "#747474"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.279 120.77C134.937 120.77 134.595 120.639 134.334 120.38C133.813 119.86 133.813 119.014 134.334 118.493L136.733 116.094C137.254 115.574 138.1 115.574 138.62 116.094C139.141 116.614 139.141 117.46 138.62 117.981L136.221 120.38C135.959 120.642 135.618 120.77 135.276 120.77H135.279Z",
    fill: "#747474"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.156 124.076C138.814 124.076 138.472 123.945 138.211 123.686C137.69 123.166 137.69 122.32 138.211 121.799L143.915 116.096C144.435 115.575 145.281 115.575 145.802 116.096C146.322 116.616 146.322 117.462 145.802 117.983L140.098 123.686C139.836 123.948 139.495 124.076 139.153 124.076H139.156Z",
    fill: "#747474"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4895 124.076C35.1479 124.076 34.8062 123.945 34.5447 123.686C34.0242 123.166 34.0242 122.32 34.5447 121.799L40.2486 116.096C40.7691 115.575 41.6153 115.575 42.1357 116.096C42.6562 116.616 42.6562 117.462 42.1357 117.983L36.4318 123.686C36.1702 123.948 35.8285 124.076 35.4869 124.076H35.4895Z",
    fill: "#747474"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6751 124.076C42.3334 124.076 41.9918 123.945 41.7302 123.686C41.2097 123.166 41.2097 122.32 41.7302 121.799L45.0373 118.492C45.5578 117.972 46.4039 117.972 46.9244 118.492C47.4449 119.013 47.4449 119.859 46.9244 120.379L43.6173 123.686C43.3557 123.948 43.0141 124.076 42.6724 124.076H42.6751Z",
    fill: "#747474"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9798 120.77C45.6381 120.77 45.2965 120.639 45.0349 120.38C44.5144 119.86 44.5144 119.014 45.0349 118.493L47.4345 116.094C47.9549 115.574 48.8011 115.574 49.3216 116.094C49.842 116.614 49.842 117.46 49.3216 117.981L46.922 120.38C46.6604 120.642 46.3188 120.77 45.9771 120.77H45.9798Z",
    fill: "#747474"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8567 124.076C49.5151 124.076 49.1734 123.945 48.9118 123.686C48.3914 123.166 48.3914 122.32 48.9118 121.799L54.6158 116.096C55.1363 115.575 55.9824 115.575 56.5029 116.096C57.0234 116.616 57.0234 117.462 56.5029 117.983L50.7989 123.686C50.5373 123.948 50.1957 124.076 49.8541 124.076H49.8567Z",
    fill: "#747474"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.4277 84.2671C101.598 86.9619 108.154 91.6772 117.02 88.9804",
    stroke: "#434343",
    strokeWidth: 3.92099,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.459 88.98C67.6859 90.2288 75.722 91.0344 82.0512 84.2666",
    stroke: "#434343",
    strokeWidth: 3.92099,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4648 105.501L63.7179 108.294",
    stroke: "#434343",
    strokeWidth: 3.92099,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.127 103.881C66.9206 105.923 74.4744 108.781 82.3397 103.881",
    stroke: "#434343",
    strokeWidth: 3.92099,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.873 105.501L116.62 108.294",
    stroke: "#434343",
    strokeWidth: 3.92099,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.211 103.881C113.417 105.923 105.864 108.781 97.9982 103.881",
    stroke: "#434343",
    strokeWidth: 3.92099,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4493 121.942L86.5664 117.549L90.9599 115.038L94.0981 117.549L91.5875 121.942H88.4493Z",
    fill: "#747474"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1684 118.383C94.1524 118.383 94.139 118.383 94.123 118.383C92.7484 118.369 91.4272 117.702 90.1807 116.394C88.9342 117.702 87.6129 118.369 86.2383 118.383C86.225 118.383 86.209 118.383 86.1929 118.383C84.0603 118.383 82.7684 116.795 82.627 116.613C82.1759 116.031 82.2826 115.193 82.8645 114.74C83.4437 114.291 84.2765 114.393 84.7276 114.967C84.7569 115.001 85.3628 115.714 86.1956 115.714C86.2063 115.714 86.217 115.714 86.2276 115.714C87.0497 115.695 87.992 114.999 88.9555 113.701C89.2064 113.363 89.6041 113.162 90.0259 113.162H90.3248C90.7465 113.162 91.1442 113.363 91.3951 113.701C92.3587 114.999 93.3009 115.695 94.123 115.714C94.1337 115.714 94.1444 115.714 94.155 115.714C95.0038 115.714 95.6177 114.975 95.6231 114.967C96.0742 114.385 96.9096 114.283 97.4915 114.734C98.0733 115.185 98.1748 116.029 97.7237 116.613C97.5822 116.795 96.2904 118.383 94.1577 118.383H94.1684Z",
    fill: "#434343"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5666 116.105C87.3639 116.105 88.0102 116.751 88.0102 117.548C88.0102 118.108 88.2445 119.108 88.7459 119.944C89.2502 120.784 89.804 121.126 90.3325 121.126C91.1724 121.126 91.7025 120.681 92.101 119.884C92.5245 119.037 92.6547 118.017 92.6547 117.548C92.6547 116.751 93.301 116.105 94.0983 116.105C94.8956 116.105 95.5419 116.751 95.5419 117.548C95.5419 118.335 95.3583 119.825 94.6834 121.175C93.9835 122.575 92.6307 124.013 90.3325 124.013C88.3504 124.013 87.0213 122.681 86.2702 121.429C85.5164 120.173 85.123 118.663 85.123 117.548C85.123 116.751 85.7694 116.105 86.5666 116.105Z",
    fill: "#434343"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6178 54.1887L32.5812 58.4857L31.1233 58.8764L30.7327 57.4185L27.8658 46.7192C26.1385 40.2726 25.8099 32.3612 31.168 27.211C33.4298 25.0371 36.3665 23.0953 40.0238 22.1153C43.6811 21.1354 47.1953 21.3486 50.2409 22.1004C57.4563 23.8816 61.1275 30.8974 62.8548 37.3439L65.7217 48.0432L66.1123 49.5011L64.6545 49.8917L48.6178 54.1887Z",
    fill: "#747474"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.8145,
    y: 58.1992,
    width: 42.2605,
    height: 9.05586,
    transform: "rotate(-15 27.8145 58.1992)",
    fill: "#B5B5B5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8661 6.60955C37.1836 6.25652 38.5379 7.03841 38.8909 8.35595L41.2348 17.1032C41.5878 18.4208 40.8059 19.775 39.4884 20.1281C38.1708 20.4811 36.8166 19.6992 36.4635 18.3817L34.1197 9.6344C33.7667 8.31686 34.5485 6.96259 35.8661 6.60955Z",
    fill: "#B5B5B5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1467 7.90579C58.328 8.5878 58.7327 10.0983 58.0507 11.2796L53.5228 19.1222C52.8408 20.3035 51.3303 20.7082 50.149 20.0262C48.9678 19.3442 48.563 17.8337 49.245 16.6524L53.7729 8.80979C54.4549 7.62851 55.9654 7.22378 57.1467 7.90579Z",
    fill: "#B5B5B5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.437 18.2783C17.755 19.4596 18.1597 20.9701 19.341 21.6521L27.1836 26.18C28.3648 26.862 29.8753 26.4573 30.5573 25.276C31.2393 24.0947 30.8346 22.5842 29.6533 21.9022L21.8108 17.3743C20.6295 16.6923 19.119 17.097 18.437 18.2783Z",
    fill: "#B5B5B5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9629 26.7739C48.6531 27.0948 54.5023 29.486 56.3774 36.4838",
    stroke: "white",
    strokeWidth: 2.46978,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportModalIcon);
export default __webpack_public_path__ + "static/media/ReportModalIcon.d4484dbf9a9f4a45b0dbb8631139741e.svg";
export { ForwardRef as ReactComponent };